import CompletedScreen from './CompletedScreen'

export default CompletedScreen;
